/* Korax Performance theme script: cart drawer, product form (piece or set), menus, signup. */
(() => {
  'use strict';
  const K = window.KORAX || {
    routes: { root: '', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', collections: '/collections' },
    strings: {}, freeShippingCents: 7500, shippingRateCents: 699, moneyFormat: '${{amount}}'
  };
  /* Liquid's t filter HTML-escapes apostrophes (You&#39;re); decode once, every use below re-escapes or uses textContent. */
  const S = (() => {
    const raw = K.strings || {}, out = {}, ta = document.createElement('textarea');
    Object.keys(raw).forEach(k => { ta.innerHTML = String(raw[k] == null ? '' : raw[k]); out[k] = ta.value; });
    return out;
  })();
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* storage unavailable */ } }
  };
  const fill = (str, map) => String(str || '').replace(/%(\w+)%/g, (m, k) => (map[k] != null ? map[k] : m));

  function formatMoney(cents) {
    const fmt = K.moneyFormat || '${{amount}}';
    const value = (Number(cents) || 0) / 100;
    const delim = (n, d, t, dec) => { const p = n.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t); return p.join(dec); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      if (k === 'amount_no_decimals') return delim(value, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return delim(value, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return delim(value, 0, '.', ',');
      return delim(value, 2, ',', '.');
    }).replace(/<[^>]*>/g, '');
  }
  const moneyShort = c => (Number(c) % 100 === 0 ? formatMoney(c).replace(/[.,]00(?=\D*$)/, '') : formatMoney(c));
  const sized = (src, w) => (src ? src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w : '');

  /* ---------- toast + copy ---------- */
  let toastEl = null, toastTimer = null;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('show');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => toastEl.classList.remove('show'), 1800);
  }
  function copy(text) {
    try { navigator.clipboard.writeText(text).then(() => toast(S.copied || 'Copied'), () => toast(text)); } catch (e) { toast(text); }
  }

  /* ---------- overlays ---------- */
  let lastFocus = null;
  const lock = on => document.documentElement.classList.toggle('locked', on);
  const drawer = () => $('#CartDrawer');
  function anyOpen() {
    const m = $('#MenuOverlay'), s = $('#SignupPopup'), d = drawer();
    return !!((m && !m.hidden) || (s && !s.hidden) || (d && d.classList.contains('open')));
  }
  function refocus() { if (lastFocus && document.contains(lastFocus) && lastFocus.focus) lastFocus.focus(); }
  function openMenu() {
    const m = $('#MenuOverlay'); if (!m) return;
    lastFocus = document.activeElement; m.hidden = false; lock(true);
    $$('[data-open-menu]').forEach(b => b.setAttribute('aria-expanded', 'true'));
    const c = $('[data-close-menu]', m); if (c) c.focus();
  }
  function closeMenu() {
    const m = $('#MenuOverlay'); if (!m || m.hidden) return;
    m.hidden = true; lock(anyOpen());
    $$('[data-open-menu]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    refocus();
  }
  function openSignup() {
    const m = $('#SignupPopup'); if (!m || !m.hidden) return;
    closeMenu(); closeDrawer();
    lastFocus = document.activeElement; m.hidden = false; lock(true);
    const c = $('[data-close-signup]', m); if (c) c.focus();
  }
  function closeSignup() {
    const m = $('#SignupPopup'); if (!m || m.hidden) return;
    m.hidden = true; store.set('korax.signupSeen', true); lock(anyOpen()); refocus();
  }

  /* ---------- cart ---------- */
  function openDrawer() {
    const d = drawer(); if (!d) return false;
    lastFocus = document.activeElement;
    d.inert = false; d.classList.add('open');
    const scrim = $('#CartScrim'); if (scrim) scrim.hidden = false;
    lock(true); refreshCart();
    setTimeout(() => { const b = $('[data-close-drawer]', d); if (b) b.focus(); }, 40);
    return true;
  }
  function closeDrawer() {
    const d = drawer(); if (!d || !d.classList.contains('open')) return;
    d.classList.remove('open'); d.inert = true;
    const scrim = $('#CartScrim'); if (scrim) scrim.hidden = true;
    lock(anyOpen()); refocus();
  }
  async function getCart() {
    const r = await fetch(K.routes.cart + '.js', { headers: { Accept: 'application/json' } });
    return r.json();
  }
  async function refreshCart() { try { renderCart(await getCart()); } catch (e) { /* keep the server-rendered drawer */ } }
  function renderCart(cart) {
    $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
    const title = $('#CartDrawerTitle'); if (title) title.textContent = fill(S.cartTitle, { count: cart.item_count });
    const body = $('#CartDrawerBody'), foot = $('#CartDrawerFoot');
    if (!body || !foot) return;
    if (!cart.item_count) {
      body.innerHTML = `<div class="empty"><p>${esc(S.cartEmpty)}</p><a class="btn btn--dark" href="${esc(K.routes.collections)}/all">${esc(S.cartShop)}</a></div>`;
      foot.hidden = true;
      return;
    }
    const total = cart.total_price;
    const left = Math.max(0, K.freeShippingCents - total);
    const pct = Math.min(100, (total / K.freeShippingCents) * 100);
    let html = `<div class="freebar"><span>${esc(left > 0 ? fill(S.freeLeft, { amount: formatMoney(left) }) : S.freeYes)}</span><div class="freebar__track"><div class="freebar__fill" style="width:${pct.toFixed(1)}%"></div></div></div>`;
    cart.items.forEach((item, i) => {
      const line = i + 1;
      const img = item.image ? `<img src="${esc(sized(item.image, 200))}" alt="" width="72" height="96" loading="lazy">` : '';
      const opts = (item.options_with_values || []).filter(o => o.name !== 'Title').map(o => esc(o.value)).join(' · ');
      const discs = (item.line_level_discount_allocations || []).filter(a => a.amount > 0).map(a => `<div class="line__disc">${esc((a.discount_application && a.discount_application.title) || S.savings)} (−${esc(formatMoney(a.amount))})</div>`).join('');
      const was = item.original_line_price > item.final_line_price ? `<s>${esc(formatMoney(item.original_line_price))}</s> ` : '';
      html += `<div class="line">
        <a href="${esc(item.url)}">${img}</a>
        <div><a class="line__name" href="${esc(item.url)}">${esc(item.product_title)}</a>${opts ? `<div class="line__meta">${opts}</div>` : ''}${discs}
          <div class="qty"><button type="button" data-line="${line}" data-qty="${item.quantity - 1}" aria-label="${esc(S.qtyLess)}">−</button><span>${item.quantity}</span><button type="button" data-line="${line}" data-qty="${item.quantity + 1}" aria-label="${esc(S.qtyMore)}">+</button></div></div>
        <div class="line__right"><span>${was}${esc(formatMoney(item.final_line_price))}</span><button class="tbtn muted" type="button" data-line="${line}" data-qty="0">${esc(S.remove)}</button></div>
      </div>`;
    });
    body.innerHTML = html;
    const savings = cart.total_discount || 0;
    const ship = total >= K.freeShippingCents ? 0 : K.shippingRateCents;
    foot.hidden = false;
    foot.innerHTML = `<div class="sumrow"><span>${esc(S.subtotal)}</span><span>${esc(formatMoney(cart.original_total_price))}</span></div>`
      + (savings > 0 ? `<div class="sumrow sumrow--save"><span>${esc(S.savings)}</span><span>−${esc(formatMoney(savings))}</span></div>` : '')
      + `<div class="sumrow"><span>${esc(S.shipping)}</span><span>${ship ? esc(formatMoney(ship)) : esc(S.free)}</span></div>`
      + `<div class="sumrow sumrow--total"><span>${esc(S.total)}</span><span>${esc(formatMoney(total + ship))}</span></div>`
      + `<p class="drawer__note">${esc(S.codeNote)}</p>`
      + `<a class="btn btn--dark btn--block" href="/checkout">${esc(S.checkout)}</a>`;
  }
  async function changeLine(line, quantity) {
    try {
      const r = await fetch(K.routes.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity: Math.max(0, quantity) })
      });
      renderCart(await r.json());
    } catch (e) { toast(S.addError); }
  }
  async function addItems(items) {
    const r = await fetch(K.routes.cartAdd + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!r.ok) {
      let msg = S.addError;
      try { const j = await r.json(); if (j && j.description) msg = j.description; } catch (e) { /* keep default */ }
      throw new Error(msg);
    }
    return r.json();
  }

  /* ---------- product page ---------- */
  function initProduct() {
    const section = $('[data-product-section]'); if (!section) return;
    const read = sel => { const el = $(sel, section); try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } };
    const product = read('[data-product-json]');
    const sibling = read('[data-sibling-json]');
    const cfg = read('[data-pdp-config]') || {};
    if (!product || !product.variants) return;
    const form = $('[data-product-form]', section);
    const idInput = $('[data-variant-input]', section);
    const priceEl = $('[data-price]', section);
    const addBtn = $('[data-add-btn]', section);
    const errEl = $('[data-error]', section);
    const gallery = $('[data-gallery]', section);
    const current = product.variants.find(v => v.id === cfg.currentVariant) || product.variants[0];
    const state = { color: current.option1, mode: 'piece', size: null, top: null, bottom: null };
    const topP = sibling ? (cfg.isTop ? product : sibling) : null;
    const botP = sibling ? (cfg.isTop ? sibling : product) : null;
    const fileOf = src => String(src || '').split('?')[0].split('/').pop();
    const srcOf = v => (v && ((v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src) || (v.featured_image && v.featured_image.src))) || '';
    const keyOf = v => { const parts = fileOf(srcOf(v)).split('.')[0].split('-'); return parts.length > 1 ? parts[parts.length - 2] : ''; };
    const find = (p, color, size) => (p ? p.variants.find(v => v.option1 === color && (size == null || v.option2 === size)) : null);
    const needsSize = p => !!(p && p.variants.some(v => v.option2));
    const pick = (p, color, size) => (p && needsSize(p) && !size ? null : find(p, color, size));
    const slotKey = slot => (slot === 'main' ? 'size' : slot);

    function updateGallery() {
      if (!gallery) return;
      const figs = $$('figure[data-file]', gallery);
      if (!figs.length) return;
      const key = keyOf(find(product, state.color));
      let shown = figs;
      if (key) {
        const match = figs.filter(f => (f.dataset.file || '').indexOf('-' + key + '-') !== -1);
        if (match.length) shown = match;
      }
      figs.forEach(f => { f.hidden = shown.indexOf(f) === -1; f.classList.remove('wide'); });
      if (shown.length % 2 === 1) {
        const look = shown.find(f => f.dataset.file.indexOf('-look-') !== -1) || shown[0];
        gallery.insertBefore(look, gallery.firstChild);
        look.classList.add('wide');
      }
    }

    function sync() {
      $$('.swatch', section).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.color === state.color)));
      const cn = $('[data-color-name]', section); if (cn) cn.textContent = state.color;
      $$('[data-mode]', section).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.mode === state.mode)));
      const setMode = state.mode === 'set' && !!sibling;
      const rows = { main: $('[data-size-row="main"]', section), top: $('[data-size-row="top"]', section), bottom: $('[data-size-row="bottom"]', section) };
      if (rows.main) rows.main.hidden = setMode;
      if (rows.top) rows.top.hidden = !setMode;
      if (rows.bottom) rows.bottom.hidden = !setMode;
      const note = $('[data-set-note]', section); if (note) note.hidden = !setMode;
      $$('.size', section).forEach(b => {
        const slot = b.dataset.slot;
        const p = slot === 'main' ? product : slot === 'top' ? topP : botP;
        const v = find(p, state.color, b.dataset.size);
        b.dataset.soldout = String(!(v && v.available));
        b.setAttribute('aria-pressed', String(state[slotKey(slot)] === b.dataset.size));
      });
      Object.keys(rows).forEach(slot => {
        const row = rows[slot]; if (!row) return;
        const label = $('[data-size-name]', row); if (label) label.textContent = state[slotKey(slot)] || '';
      });
      if (setMode) {
        const t = pick(topP, state.color, state.top), b = pick(botP, state.color, state.bottom);
        const base = (t || find(topP, state.color) || { price: 0 }).price + (b || find(botP, state.color) || { price: 0 }).price;
        const setPrice = base - (cfg.setOff || 0);
        priceEl.innerHTML = `${esc(moneyShort(setPrice))} <s>${esc(moneyShort(base))}</s> <span class="label muted">${esc(S.save)}</span>`;
        const ready = !!(t && b), avail = ready && t.available && b.available;
        addBtn.disabled = ready && !avail;
        addBtn.setAttribute('aria-disabled', String(!ready));
        addBtn.textContent = ready ? (avail ? `${S.addSet} · ${moneyShort(setPrice)}` : S.soldOut) : S.selectSizes;
      } else {
        const v = pick(product, state.color, state.size);
        const show = v || find(product, state.color) || current;
        priceEl.textContent = moneyShort(show.price);
        const ready = !!v;
        addBtn.disabled = ready && !v.available;
        addBtn.setAttribute('aria-disabled', String(!ready));
        addBtn.textContent = ready ? (v.available ? `${S.add} · ${moneyShort(v.price)}` : S.soldOut) : S.selectSize;
        if (v && idInput) {
          idInput.value = v.id;
          try { const u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) { /* ignore */ }
        }
      }
    }
    const showErr = msg => { errEl.textContent = msg; errEl.hidden = false; };

    section.addEventListener('click', e => {
      const sw = e.target.closest('.swatch');
      if (sw) { state.color = sw.dataset.color; errEl.hidden = true; updateGallery(); sync(); return; }
      const md = e.target.closest('[data-mode]');
      if (md) { state.mode = md.dataset.mode; errEl.hidden = true; sync(); return; }
      const sz = e.target.closest('.size');
      if (sz) { state[slotKey(sz.dataset.slot)] = sz.dataset.size; errEl.hidden = true; sync(); }
    });
    form.addEventListener('submit', async e => {
      e.preventDefault();
      errEl.hidden = true;
      let items;
      if (state.mode === 'set' && sibling) {
        const t = pick(topP, state.color, state.top), b = pick(botP, state.color, state.bottom);
        if (!t || !b) { showErr(S.needSizes); return; }
        items = [{ id: t.id, quantity: 1 }, { id: b.id, quantity: 1 }];
      } else {
        const v = pick(product, state.color, state.size);
        if (!v) { showErr(S.needSize); return; }
        items = [{ id: v.id, quantity: 1 }];
      }
      addBtn.disabled = true;
      try { await addItems(items); openDrawer(); } catch (err) { showErr(err.message || S.addError); } finally { addBtn.disabled = false; sync(); }
    });
    updateGallery();
    sync();
  }

  /* ---------- announcement ---------- */
  function initAnnouncement() {
    const bar = $('[data-announce]'); if (!bar) return;
    const msgs = $$('.announce__msg', bar);
    if (msgs.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let i = 0;
    setInterval(() => { if (document.hidden) return; msgs[i].hidden = true; i = (i + 1) % msgs.length; msgs[i].hidden = false; }, 5000);
  }

  /* ---------- events ---------- */
  document.addEventListener('click', e => {
    const el = e.target.closest('[data-open-cart],[data-close-drawer],[data-open-menu],[data-close-menu],[data-open-signup],[data-close-signup],[data-bot],[data-copy],[data-rail],[data-line]');
    if (!el) {
      if (e.target.id === 'CartScrim') closeDrawer();
      if (e.target.id === 'SignupPopup') closeSignup();
      return;
    }
    if (el.hasAttribute('data-open-cart')) { if (openDrawer()) e.preventDefault(); return; }
    if (el.hasAttribute('data-close-drawer')) { closeDrawer(); return; }
    if (el.hasAttribute('data-open-menu')) { openMenu(); return; }
    if (el.hasAttribute('data-close-menu')) { closeMenu(); return; }
    if (el.hasAttribute('data-open-signup')) { e.preventDefault(); openSignup(); return; }
    if (el.hasAttribute('data-close-signup')) { closeSignup(); return; }
    if (el.hasAttribute('data-bot')) { closeMenu(); closeDrawer(); if (window.KoraxBot) window.KoraxBot.open(el.getAttribute('data-bot') || undefined); return; }
    if (el.hasAttribute('data-copy')) { copy(el.getAttribute('data-copy')); return; }
    if (el.hasAttribute('data-rail')) {
      const sec = el.closest('section'); const rail = sec && sec.querySelector('.rail');
      if (rail) rail.scrollBy({ left: Number(el.dataset.rail) * rail.clientWidth * 0.9, behavior: 'smooth' });
      return;
    }
    if (el.hasAttribute('data-line')) { changeLine(Number(el.dataset.line), Number(el.dataset.qty)); }
  });
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    const s = $('#SignupPopup');
    if (s && !s.hidden) { closeSignup(); return; }
    const m = $('#MenuOverlay');
    if (m && !m.hidden) { closeMenu(); return; }
    closeDrawer();
  });

  function init() {
    initAnnouncement();
    initProduct();
    const popup = $('#SignupPopup');
    if (popup) {
      const posted = window.location.search.indexOf('customer_posted=true') !== -1;
      if (posted && $('.signup-done', popup)) { openSignup(); store.set('korax.signupSeen', true); }
      else if (!store.get('korax.signupSeen', false) && !document.body.classList.contains('template-password')) {
        setTimeout(() => {
          const bot = document.querySelector('.kxb-panel');
          if (!anyOpen() && !(bot && !bot.hidden)) openSignup();
        }, 9000);
      }
    }
  }
  window.Korax = { openSignup, openDrawer, refreshCart };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
